"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useMemo } from "react";
export interface SearchQueryContextValue {
  profileSummary: string | null;
  rerankInstruction: string;
  searchQuestion: string | null;
}
const DEFAULT_SEARCH_QUERY_CONTEXT: SearchQueryContextValue = {
  searchQuestion: null,
  rerankInstruction: "",
  profileSummary: null
};
const SearchQueryContext = createContext<SearchQueryContextValue>(DEFAULT_SEARCH_QUERY_CONTEXT);
SearchQueryContext.displayName = "SearchQueryContext";
interface SearchQueryProviderProps {
  children: ReactNode;
  profileSummary: string | null;
  rerankInstruction: string | null | undefined;
  searchQuestion: string | null;
}
export function SearchQueryProvider(t0) {
  const $ = _c(7);
  const {
    searchQuestion,
    rerankInstruction,
    profileSummary,
    children
  } = t0;
  const t1 = rerankInstruction ?? "";
  let t2;
  if ($[0] !== profileSummary || $[1] !== searchQuestion || $[2] !== t1) {
    t2 = {
      searchQuestion,
      rerankInstruction: t1,
      profileSummary
    };
    $[0] = profileSummary;
    $[1] = searchQuestion;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const value = t2;
  let t3;
  if ($[4] !== children || $[5] !== value) {
    t3 = <SearchQueryContext.Provider value={value}>{children}</SearchQueryContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function useSearchQueryContext() {
  return useContext(SearchQueryContext);
}